module.exports = __webpack_public_path__ + "img/23.e04961c8.png";